import { RouterPathes } from 'shared/constants'
import { GameModes, GameModeType } from 'shared/types'
import { featureFlags } from './app-feature-flags'

/** A game mode by either of the names the app uses (`GameModeType`, `GameModes`). */
export type ModeName = GameModeType | `${GameModes}`

/** Modes with no off-chain version: hidden while `offchainOnly` is on. */
export const ONCHAIN_ONLY_MODES: readonly ModeName[] = [
  'memeWars',
  'setups',
  'oneVsOne'
]

/** The game screen and the onboarding page of every on-chain-only mode. */
const ONCHAIN_ONLY_MODE_BY_PATH: Readonly<Record<string, ModeName>> = {
  [RouterPathes.memeWars]: 'memeWars',
  [RouterPathes.onboardingMemeWars]: 'memeWars',
  [RouterPathes.setups]: 'setups',
  [RouterPathes.onboardingSetups]: 'setups',
  [RouterPathes.oneVsOne]: 'oneVsOne',
  [RouterPathes.onboardingOneVsOne]: 'oneVsOne'
}

/** False for a mode the stand hides: Meme Wars, Setups and 1vs1 under `offchainOnly`. */
export const isModeAvailable = (mode: ModeName) =>
  !featureFlags.offchainOnly || !ONCHAIN_ONLY_MODES.includes(mode)

/**
 * False for a link into a hidden mode: its screen (`/setups`,
 * `/setups/?gameId=…`) or its onboarding page. Any other path is available.
 */
export const isPathAvailable = (path: string) => {
  const pathname = path.split(/[?#]/)[0].replace(/(.)\/+$/, '$1')
  const mode = ONCHAIN_ONLY_MODE_BY_PATH[pathname]

  return !mode || isModeAvailable(mode)
}
